import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'bepatient-button',
  templateUrl: './bepatient-button.component.html',
  styleUrls: ['./bepatient-button.component.scss'],
  standalone: false
})
export class BepatientButtonComponent implements OnInit, AfterViewInit {
  _color: string;
  @Input() label: string;
  @Input() disabled = false;
  @Input() set color(value: string) {
    this._color = value;
  }
  @Output() buttonClicked = new EventEmitter<boolean>();

  @ViewChild('buttonField', { read: ElementRef }) set buttonField(
    v: ElementRef
  ) {
    this.setColor(v);
  }

  constructor() {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  onButtonClick(): void {
    if (!this.disabled) {
      this.buttonClicked.emit(true);
    }
  }

  private setColor(element: ElementRef): void {
    if (element) {
      const style = element.nativeElement.style;
      const colors = ['var(--ion-color-primary-contrast)', this._color];

      style.setProperty('--color', colors[0]);
      style.setProperty('--color-activated', colors[0]);
      style.setProperty('--color-focused', colors[0]);
      style.setProperty('--background', colors[1]);
      style.setProperty('--background-activated', colors[1]);
      style.setProperty('--background-focused', colors[1]);
    }
  }
}
